// extracted by mini-css-extract-plugin
export default {"conversionTypeSelection":"styles_conversionTypeSelection__VCXom","mt32":"styles_mt32__gdyPq","displayTableWrapper":"styles_displayTableWrapper__UqLBU"};